import { chipBase, chipVariant } from "./StatusChip.css";

export interface StatusChipProps {
  variant: "success" | "warning" | "error";
  label: string;
}

export function StatusChip({ variant, label }: StatusChipProps) {
  return <div className={`${chipBase} ${chipVariant[variant]}`}>{label}</div>;
}
